import styled from 'styled-components';

const ArchiveDialogButtonBar = styled.div`
  display: grid;
  grid-template-columns: 12rem 12rem 1fr;
  grid-column-gap: ${(props): string => props.theme.spaces.lg};
`;

export { ArchiveDialogButtonBar };
